import cronstrue from 'cronstrue'

export const getTimeFromCronExp = expression => cronstrue.toString(expression,
   {
      verbose: true,
      use24HourTimeFormat: true,
   })